"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function literalArray() {
    var entries = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        entries[_i] = arguments[_i];
    }
    return entries;
}
exports.literalArray = literalArray;
//# sourceMappingURL=literalArray.js.map